let pathsToCheck;
let currentEtags;

const getEtags = async (paths) =>
  Promise.all(
    paths.map((path) =>
      fetch(`${path}?timestamp=${Date.now()}`, { method: "HEAD" })
        .then((res) => {
          if (!res.ok) return null;
          return res.headers.get("etag");
        })
        .catch(() => null),
    ),
  );

const check = async (action) => {
  const latest = await getEtags(pathsToCheck);
  if (
    latest.some(
      (change, index) =>
        change != null &&
        currentEtags[index] != null &&
        change !== currentEtags[index],
    )
  )
    action();
};

const checkVersions = async (paths, action, interval = 10000) => {
  pathsToCheck = paths;
  currentEtags = await getEtags(paths);
  setInterval(() => check(action), interval);
};

export { checkVersions };
